import { ensureSession } from '@/lib/session';
import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authed/admin')({
  beforeLoad: async ({ context }) => {
    const state = await ensureSession(context.queryClient);
    if (state.status !== 'authenticated') {
      throw redirect({ to: '/signin' });
    }
    if (state.session.role !== 'admin' && state.session.role !== 'auditor') {
      throw redirect({ to: '/chat' });
    }
  },
  component: AdminLayout,
});

function AdminLayout() {
  return (
    <main
      className="mx-auto flex w-full max-w-5xl flex-col gap-6 px-4 py-8"
      data-testid="admin-route"
    >
      <Outlet />
    </main>
  );
}
